export var scrollToElement = function (targetId) {
    var targetElement = document.getElementById(targetId);
    if (targetElement) {
        var rect = targetElement.getBoundingClientRect();
        window.scrollTo({
            behavior: "smooth",
            top: rect.top + window.scrollY - 100,
            left: 0,
        });
    }
};
